import {Component, OnInit} from '@angular/core';
import {PublicationService} from "../../../../services/publication.service";
import {IPost, Post} from "../../../../models/post.model";
import Swal from "sweetalert2";
import {environment} from "../../../../environments/environment";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {Note} from "../../../../models/NotePost";
import * as XLSX from "xlsx";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {

  posts: Post[] = [];
  initialPosts: Post[] = [];
  perPage: number = 1;
  pageSize: number = 10;
  totalItems :any;

  post!: Post;
  postUpdate!: Post;
  nbTotalPurchase: number = 0;
  url_photo: String;

  unitTime: string [] = [];

  notePosts: Note[] = [];

  search: any;

  allowDeliveryChecked: boolean = false;

  constructor(private postService: PublicationService,
              private fb: FormBuilder,
              private router: Router,
              private datePipe: DatePipe) {
    this.unitTime = ['Minutes', 'Heurs', 'Jours', 'Mois'];
  }

  ngOnInit(): void {
    this.allPosts();
    this.url_photo = environment.url_photo;
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  updateProdFormGroup = this.fb.group({
    /*price: new FormControl('', [Validators.required]),*/
    description: new FormControl('', [Validators.required]),
    /*allowDelivery: new FormControl(null),
    pickFormShop: new FormControl(null),
    unitDeliveryDuration: new FormControl(''),
    deliveryDelay: new FormControl(''),*/
  });

  updateServFormGroup = this.fb.group({
    /*price: new FormControl('', [Validators.required]),*/
    description: new FormControl('', [Validators.required])
  });

  allPosts() {
    this.postService.allPosts(this.perPage-1, this.pageSize).subscribe(data => {
      this.posts = data;
      this.totalItems = data.totalElements;
      this.initialPosts = this.posts;
     // console.log("Liste des publications");
     // console.log(this.posts)
    })
  }

  enablePost(postId: number) {
    this.postService.enablePost(postId).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  disablePost(postId: number) {
    this.postService.disablePost(postId).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
    }, error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  postDetails(id: number) {
   // console.log(id);
    this.postService.totalPurchase(id).subscribe(data => {
      this.nbTotalPurchase = data;
    }, error => {
     // console.log(error);
    });

    this.postService.getPost(id).subscribe(data => {
      this.post = data;
    }, error => {
      //console.log(error);
    });

    this.getNotesAndCommentByPostId(id);
  }

  getNotesAndCommentByPostId(id: number){
    this.postService.notesAndCommentsByPostId(id).subscribe(data => {
      this.notePosts = data;
     // console.log(this.notePosts);
    }, error => {
      //console.log(error);
    })
  }

  handleUpdate(id: number) {
    this.postService.getPost(id).subscribe(rs => {
      this.postUpdate = rs;

      if (this.postUpdate.postProducts.length > 0) {
        this.updateProdFormGroup.patchValue({
          /*price: post.postProducts[0].price,*/
          description: this.postUpdate.description
        })
      }

      if (this.postUpdate.postServiceModels.length > 0) {
        this.updateServFormGroup.patchValue({
          /*price: post.postServiceModels[0].price,*/
          description: this.postUpdate.description
        })
      }
    })
  }

  updatePubProd() {
    //const price = this.updateProdFormGroup.get(['price']).value;
    const description = this.updateProdFormGroup.get(['description']).value;

    /*const allowDelivery = this.updateProdFormGroup.get(['allowDelivery']).value;
    const pickFormShop = this.updateProdFormGroup.get(['pickFormShop']).value;
    const unitDeliveryDuration = this.updateProdFormGroup.get(['unitDeliveryDuration']).value;
    const deliveryDelay = this.updateProdFormGroup.get(['deliveryDelay']).value;*/

    /*if (this.allowDeliveryChecked && unitDeliveryDuration == null && this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner l\'unité de temps et le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez remplir le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && unitDeliveryDuration == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir l\'unité de temps',
        showConfirmButton: false,
        timer: 1500
      });
    }*/

    let post: IPost = this.postUpdate;
    post.description = description;
    //post.postProducts[0].price = price;

    this.postService.updatePost(post).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.reloadComponent();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  updateServPub() {
    //const price = this.updateServFormGroup.get(['price']).value;
    const description = this.updateServFormGroup.get(['description']).value;

    let post: IPost = this.postUpdate;
    // post.postServiceModels[0].price = price;
    post.description = description;

    this.postService.updatePost(post).subscribe(data => {
    //  console.log(data);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.reloadComponent();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  /*hideDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = false;
  }*/

  /*showDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = true;
  }*/

  deletePost(id: number) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette publication ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postService.deletePost(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Publication supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
          //  console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
  }

  searchPost($event: KeyboardEvent) {
    this.postService.all().subscribe(data => {
      this.posts = data;
      this.totalItems = data.totalElements;
      this.posts = this.posts.filter(value =>
        value?.title.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.description.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.status?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.postProducts[0]?.product?.productID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.postProducts[0]?.product?.category?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        (Number(this.search) === value?.postProducts[0]?.finalPrice) ||
        value?.postServiceModels[0]?.serviceModel?.serviceID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.postServiceModels[0]?.serviceModel?.serviceID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        (Number(this.search) === value?.postServiceModels[0]?.finalPrice) ||
        value?.userID?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.userID?.lastname.toLowerCase().includes(this.search.toLowerCase().trim())
      )
    })
  }

  ascendingOrderDate: boolean = true;
  sortByDate() {
    this.posts.sort((a, b) => {
      const dateA = new Date(a.publishedAt);
      const dateB = new Date(b.publishedAt);
      if(this.ascendingOrderDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderDate = !this.ascendingOrderDate;
  }

  ascendingOrder: boolean = true;
  sortByAuthorFirstName(){
    this.posts.sort((a, b) => {
      const firstnameA = a.userID.firstname.toLowerCase();
      const firstnameB = b.userID.firstname.toLowerCase();

      if(this.ascendingOrder){
        return firstnameA.localeCompare(firstnameB);
      }else {
        return firstnameB.localeCompare(firstnameA);
      }
    })
    this.ascendingOrder = !this.ascendingOrder;
  }

  ascendingOrderTitle: boolean = true;
  sortByTitle(){
    this.posts.sort((a, b) =>{
      if(this.ascendingOrderTitle){
        return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
      }else{
        return b.title.toLowerCase().localeCompare(a.title.toLowerCase());
      }
    })
    this.ascendingOrderTitle = !this.ascendingOrderTitle;
  }

  filterByStatus(event: any) {
    let value: string = event.target.value;
    if (value == 'tous') {
      this.posts = this.initialPosts;
    } else {
      this.posts = this.initialPosts.filter(result => {
        return result.status.name.includes(value);
      })
    }
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  filterPostByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    if(beginDate == '' || endDate == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let endDateTrans: any = new Date(endDate);
    endDateTrans.setDate(endDateTrans.getDate() + 1);
    endDateTrans = this.datePipe.transform(endDateTrans,'yyyy-MM-dd');
   // console.log(endDateTrans);

    this.posts = this.initialPosts.filter(p => {
      return (p.publishedAt >= beginDate) && (p.publishedAt <= endDateTrans);
    })
  }

  refresh() {
    this.allPosts();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }
}
